import { useCallback, useState } from "react";
import { ConfirmationModal } from "../Modal/confirmationModal.js";

interface UseConfirmationModalProps {
  /** If this is set, a confirmation modal will be shown before the close handler is called. */
  needsConfirmation?: boolean;
  /** If this returns `true` when a close is triggered, a confirmation modal will be shown before the close handler is called. */
  getNeedsConfirmation?: () => boolean;
  onClose: () => void;
}

interface RenderConfirmationModalProps {
  title?: string;
  confirmText?: string;
  message?: string;
}

export const useConfirmationModal = ({
  needsConfirmation,
  getNeedsConfirmation,
  onClose: onConfirm,
}: UseConfirmationModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const renderConfirmationModal = ({
    title,
    confirmText,
    message,
  }: RenderConfirmationModalProps = {}) => (
    <ConfirmationModal
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      title={title}
      confirmText={confirmText}
      onConfirm={onConfirm}
    >
      {message}
    </ConfirmationModal>
  );

  const onConfirmThenClose = useCallback(() => {
    if (needsConfirmation || getNeedsConfirmation?.()) {
      setIsOpen(true);
    } else {
      onConfirm();
    }
  }, [needsConfirmation, getNeedsConfirmation, onConfirm]);

  return {
    renderConfirmationModal,
    onConfirmThenClose,
  };
};
